module.exports = __webpack_public_path__ + "img/Istek.3478bc5e.png";